import { Component, OnInit, OnDestroy, Inject, ViewChild, ElementRef } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { Router, ActivatedRoute } from '@angular/router';
import { FutureInfoService } from '../../_services/index';
import { FormDoneService } from '../../_services/form-done.service';
import { DOCUMENT } from '@angular/common';
import { PageScrollConfig, PageScrollService, PageScrollInstance } from 'ngx-page-scroll';
import { FileService } from '../../_services/file.service';
import { DashboardService } from '../../_services/dashboard.service';
import {APP_CONFIG, IAppConfig} from '../../app.config';
import { AuthenticationService } from './../../_services/index';
import { FormBuilder, FormControl, FormArray, FormGroup, Validators, AbstractControl } from '@angular/forms';
import swal from 'sweetalert2';

@Component({
  selector: 'app-scholarship-acceptance',
  templateUrl: './scholarship-acceptance.component.html',
  styleUrls: ['./scholarship-acceptance.component.css'],
  providers: [FutureInfoService, FormDoneService, FileService,DashboardService,AuthenticationService]
})
export class ScholarshipAcceptanceComponent implements OnInit {
  acceptanceForm: FormGroup;
  acceptanceFormSub: Subscription;
  public currentUser: any;
  public currentUserName: any;
  public fileuploadSub: Subscription;
  public filepath;
  public loading: boolean = false;
  public getdataSub: Subscription;
  public completed = 50;
  public pending;
  Application_granted = [];
  submitting = false;
  error;
  public fileSub: Subscription;
  errorFlag = false;
  personid;
  appid;
  orgid;
  year;
  public getHeaderDataSub: Subscription;
  logoUrl = 'assets/img/logo.png';
  org_name;
  cut_off_date;
  loggedin_personid;
  scholarship_amount;
  scholarship_pamount;
  Fall_amount1;
  Fall_amount2;
  Spring_amount1;
  Spring_amount2;
  Winter_amount;
  college_type;
  requiredAccept = true;
  requiredDecline = false;
  activebutton1 = false;
  activebutton2 = true;
  date_scheduled;
  fyear;
  syear;

  constructor(
    @Inject(APP_CONFIG) private config: IAppConfig,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private api: FutureInfoService,
    private formapi: FormDoneService,
    private pageScrollService: PageScrollService,
    @Inject(DOCUMENT) private document: any,
    private _fileService: FileService,
    private _DashboardService:DashboardService,
    private loginservice: AuthenticationService,
    private _fb: FormBuilder) { 
    //console.log(localStorage.getItem('currentUser'));
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.loggedin_personid = this.currentUser.personid;
    this.currentUserName = this.currentUser.firstname + ' ' + this.currentUser.lastname;
    //Object.assign(this, {this.single, multi})
    
  }

  ngOnInit() {

    this.handleUserUpdated();
    this.getApplications();
    this.createForm();
    this.activatedRoute.params.subscribe(res => {
      console.log( res.hash );
      const body = {
        'token':res.hash,
      };
      this.formapi.getPartnerDataHash$(body).subscribe(
        (dataResponse) => {
          const response = dataResponse;
          const data = JSON.parse(response._body);
          //console.log(data);
          if (data.status === 1) {
            console.log(data.data);
            this.personid = data.data.student_id;
            this.appid = data.data.app_id;
            this.orgid = data.data.org_id;
            this.year = data.data.year;

            if(this.loggedin_personid != this.personid){
              this.router.navigate(['/user-dashboard']);
            }

            this.getHeaderData();
            
          }
        },
        error => {
          this.loading = false;
          const errordata = JSON.parse(error._body);
          if (errordata.success === 0) {
            console.log(errordata.message);
            //.ErrorMassage = errordata.message;
            this.errorFlag = true;
          }
  
        }
      );

    });
    
    console.log(this.loggedin_personid);
    //console.log(this.personid);
    const element1 = document.querySelector('.droppable');
    this.makeDroppable(element1, this.callback, this);

  }

  createForm()  {

    this.acceptanceForm  = this._fb.group({
      
      iaccept: ['1'],
      iagree1: [''],
      iagree2:[''],
      iagree3: [''],
      iagree4: [''],
      iagree5: [''],
      iagree6: [''],
      iagree7: [''],
      iagree8: [''],
      iagree9: [''],
      iagree10: [''],
      iagree11: [''],
      attending: [''],
      studentid: [''],
      major: [''],
      signedby: [''],
      idecined: [''],
      reason: ['']

    });

    //console.log(this.digitalForm);
    
  }

  handleUserUpdated() {
    this.getdataSub = this.formapi.getFormData$()
    .subscribe(responsedata => {
      const formdata = responsedata.data; 
      console.log(formdata);
      this.completed = formdata.completed;
      this.pending = formdata.pending;
      if (formdata.full_path) {
        this.filepath = formdata.full_path;
      }
      
    });
  }

  getApplications() {
    this.loading = true;
    this.submitting = true;
    this.fileSub = this._fileService.getApplications$()
    .subscribe(
      data => {
        this.error = false;
        this.submitting = false;
        const response = data;
        console.log(data.data);
     
        this.Application_granted = data.data.applied.granted;
        this.loading = false;
      },
      error => {
        this.submitting = false;
        this.errorFlag = true;
        const errordata = JSON.parse(error._body);
        this.loading = false;
      },
    );
  }

  makeDroppable(element, callback, classObj) {
    const input = document.createElement('input');
    input.setAttribute('type', 'file');
    input.style.display = 'none';
    input.addEventListener('change', function (e) {
      triggerCallback(e, classObj);
    });
    element.appendChild(input);
    element.addEventListener('dragover', function(e) {
        e.preventDefault();
        e.stopPropagation();
        element.classList.add('dragover');
    });

    element.addEventListener('dragleave', function(e) {
        e.preventDefault();
        e.stopPropagation();
        element.classList.remove('dragover');
    });

    element.addEventListener('drop', function(e) {
        e.preventDefault();
        e.stopPropagation();
        element.classList.remove('dragover');
        triggerCallback(e, classObj);
    });

    element.addEventListener('click', function() {
        input.value = null;
        input.click();
    });

    function triggerCallback(e, obj) {
        let files;
        if (e.dataTransfer) {
            files = e.dataTransfer.files;
        } else if (e.target) {
            files = e.target.files;
        }
        callback.call(null, files, e, obj);
    }
  }

  callback(files, event, classobject?: any) {
    classobject.loading = true;
    for (let i = 0; i < files.length; i++) {
      let ext = '';
      const mimeType = files[i].type;
      ext = files[i].name.split('.').pop();
      const allowedMIMEType = ['image/jpeg', 'image/png'];
      if (allowedMIMEType.indexOf(mimeType) >= 0 ) {
        if ((allowedMIMEType.indexOf(mimeType) === 0) || (allowedMIMEType.indexOf(mimeType) === 1) ) {
          classobject.filetype = ext;
        }else {
          classobject.filetype = ext;
        }
        const body = {
          attachableId: '',
          file: files[i],
          attachableType: 'Profilepic'
        };
        const file = files[i];
        const img = new Image();
        img.src = window.URL.createObjectURL( file );
        img.onload = function() {
          classobject.imgWidth = img.naturalWidth,
          classobject.imgHeight = img.naturalHeight;
          window.URL.revokeObjectURL( img.src );
          if (
            (classobject.imgWidth <= '580') &&
            (classobject.imgHeight <= '580') &&
            (classobject.imgWidth >= '200') &&
            (classobject.imgHeight >= '200')) {
              classobject.fileuploadSub = classobject._fileService.uploadFile(body).subscribe(
                responsedata => {
                  const filelink = JSON.parse(responsedata._body).data.filelink;
                  classobject.filepath = filelink;
                  classobject.loading = false;
                }, error => {
                  classobject.loading = false;
              });
            } else {
              alert('Image should be of dimensions between 200x200 to 580x580 or less');
            }
        };
      } else {
        alert('File not allowed');
        classobject.loading = false;
      }
    }

  }

  getHeaderData() {
    
    const body = {
      'appid':this.appid,
      'orgid':this.orgid,
      'year':this.year
    };
    this.getHeaderDataSub = this.formapi.getPartnerData$(body).subscribe(
      responsedata => {
        //const headerData = responsedata.data;
        let data = JSON.parse(responsedata._body).data;
        if(data.record_found == 0){
          this.date_scheduled = data.date_scheduled;
          this.cut_off_date = data.cut_off_date;
          this.org_name = data.org_name;
          this.logoUrl = data.partnerLogo;
          this.scholarship_amount = data.scholarship_amount;
          this.scholarship_pamount = data.scholarship_pamount;
          this.Fall_amount1 = data.Fall_amount1;
          this.Fall_amount2 = data.Fall_amount2;
          this.Spring_amount1 = data.Spring_amount1;
          this.Spring_amount2 = data.Spring_amount2;
          this.Winter_amount = data.Winter_amount;
          this.fyear = data.fyear;
          this.syear = data.syear;
          this.college_type = data.college_type;

        }
        else
        {
          /* this.date_scheduled = data.date_scheduled;
          this.cut_off_date = data.cut_off_date;
          this.org_name = data.org_name;
          this.logoUrl = data.partnerLogo;
          this.scholarship_amount = data.scholarship_amount;
          this.scholarship_pamount = data.scholarship_pamount;
          this.Fall_amount1 = data.Fall_amount1;
          this.Fall_amount2 = data.Fall_amount2;
          this.Spring_amount1 = data.Spring_amount1;
          this.Spring_amount2 = data.Spring_amount2;
          this.Winter_amount = data.Winter_amount;
          this.fyear = data.fyear;
          this.syear = data.syear;
          this.college_type = data.college_type; */
          this.router.navigate(['/user-dashboard']);

        }

      },
      error => {
        console.log(error);
      },
    );
    
  }

  onSubmit(){
    this.loading = true;
    const acceptanceForm = this.acceptanceForm.value;
    console.log(this.scholarship_pamount);
    const body = JSON.stringify({
      'formdata': this.acceptanceForm.value,
      'appid':this.appid,
      'orgid':this.orgid,
      'year':this.year,
      'amount':this.scholarship_pamount
    });
    console.log(body);

    this.formapi.scholarshipAcceptance$(body).subscribe(
      data => {
        this.error = false;
        this.submitting = false;
        this.errorFlag = false;
        const response = JSON.parse(data._body);
        swal(response.message);
        //this.successMessage = response.message;
        this.loading = false;
        //this.dialogRef.close(response.lastInserted);
        this.getHeaderData();
      },
      error => {
        this.submitting = false;
        this.errorFlag = true;
        const errordata = JSON.parse(error._body);
        swal(errordata.message, 'error')
        if (errordata.success === 0) {
          //this.errorMessage = errordata.message;
          this.errorFlag = true;
          //this.fieldErrors = errordata.errors;
          this.loading = false;
        }
      },
    );

  }

  checkaccept(action){
    console.log(action);
    if(action == 'accept'){
      this.requiredAccept = true;
      this.requiredDecline = false;
      this.acceptanceForm.controls.idecined.setValue(false);
      this.acceptanceForm.controls['iagree1'].enable();
      this.acceptanceForm.controls['iagree2'].enable();
      this.acceptanceForm.controls['iagree3'].enable();
      this.acceptanceForm.controls['iagree4'].enable();
      this.acceptanceForm.controls['iagree5'].enable();
      this.acceptanceForm.controls['iagree6'].enable();
      this.acceptanceForm.controls['iagree7'].enable();
      this.acceptanceForm.controls['iagree8'].enable();
      this.acceptanceForm.controls['iagree9'].enable();
      this.acceptanceForm.controls['iagree10'].enable();
      this.acceptanceForm.controls['iagree11'].enable();
      this.acceptanceForm.controls['reason'].setValue('');
      this.activebutton1 = false;
      this.activebutton2 = true;
    }
    else
    {
      this.requiredAccept = false;
      this.requiredDecline = true;
      this.acceptanceForm.controls.iaccept.setValue(false);

      this.acceptanceForm.controls['iagree1'].setValue(false);
      this.acceptanceForm.controls['iagree2'].setValue(false);
      this.acceptanceForm.controls['iagree3'].setValue(false);
      this.acceptanceForm.controls['iagree4'].setValue(false);
      this.acceptanceForm.controls['iagree5'].setValue(false);
      this.acceptanceForm.controls['iagree6'].setValue(false);
      this.acceptanceForm.controls['iagree7'].setValue(false);
      this.acceptanceForm.controls['iagree8'].setValue(false);
      this.acceptanceForm.controls['iagree9'].setValue(false);
      this.acceptanceForm.controls['iagree10'].setValue(false);
      this.acceptanceForm.controls['iagree11'].setValue(false);

      this.acceptanceForm.controls['attending'].setValue('');
      this.acceptanceForm.controls['studentid'].setValue('');
      this.acceptanceForm.controls['major'].setValue('');
      this.acceptanceForm.controls['signedby'].setValue('');

      this.acceptanceForm.controls['iagree1'].disable();
      this.acceptanceForm.controls['iagree2'].disable();
      this.acceptanceForm.controls['iagree3'].disable();
      this.acceptanceForm.controls['iagree4'].disable();
      this.acceptanceForm.controls['iagree5'].disable();
      this.acceptanceForm.controls['iagree6'].disable();
      this.acceptanceForm.controls['iagree7'].disable();
      this.acceptanceForm.controls['iagree8'].disable();
      this.acceptanceForm.controls['iagree9'].disable();
      this.acceptanceForm.controls['iagree10'].disable();
      this.acceptanceForm.controls['iagree11'].disable();

      this.activebutton2 = false;
      this.activebutton1 = true;
    }
    
  }

}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/scholarship-acceptance/scholarship-acceptance.component.ts